import BaseGameFactory from "../../core/src/factories/BaseGameFactory";
import BaseSettings from "../../core/src/ui/BaseSettings";
import UIDesktopView from "../base/ui/UIDesktop";
import BaseUI from "../../core/src/ui/BaseUI";
import AutoplayPage from "../base/ui/AutoplayPopup";
import VendorPreloadView from "../view/VendorPreloadView";
import InfoBar from '../base/ui/InfoBar';
import VendorSettings from "../../../vendor_core/src/base/ui/VendorSettings";
import VendorErrorPopup from '../ui/popups/VendorErrorPopup';


export class GameFactory extends BaseGameFactory {
    protected getSettings(): BaseSettings {
        return new  VendorSettings();
    }

    protected getAutoplayPage(): BaseUI {
        return new AutoplayPage();
    }

    protected getUIView(): BaseUI {
        return new UIDesktopView();
    }

    protected getInfoBar(): BaseUI {
        return new InfoBar();
    }

    protected getPreloadView() {
        return new VendorPreloadView();
    }
    protected getErrorPopup() {
        return new VendorErrorPopup();
    }
}

export default GameFactory;
